module.exports = __webpack_public_path__ + "img/quest_icon_0017_critical.40c53773.png";